import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

/**
 * Top-right SIM badge — only renders in `?simulate=...` mode so
 * screenshot reviewers can tell at a glance the page is running on
 * the sim driver, not real data. Low-key but always visible.
 */
export function SimBadge({
    simMode
}: {
    simMode: string | null | undefined;
}): React.ReactElement | null {
    if (!simMode) return null;
    return (
        <div className="absolute top-3 right-3 z-50 px-2 py-1 bg-charcoal text-paper">
            <Text
                variant="fine-print"
                render={<span />}
                className="font-numeric-mono uppercase tracking-wide"
            >
                SIM: {simMode}
            </Text>
        </div>
    );
}
